import { Case, Client, Jurisdiction, User } from 'briefpoint-client';
import { Button, Row, Table } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import Loading from 'components/Loading';
import { leadAttorneyName } from 'screens/CaseManagement/case';

interface Props {
  addCase: () => void;
  cases: Case[] | undefined
  client: Client;
  jurisdictions: Jurisdiction[] | undefined;
  users: User[] | null;
  showIfEmpty: boolean
}

export default function CaseTable({ addCase, cases, client, jurisdictions, users, showIfEmpty }: Props) {

  function venueDisplay(_case: Case) {
    const j = jurisdictions?.find(x => x.id === _case.jurisdiction);

    return j?.venues?.find(x => x.id === _case.venue)?.shortName ?? '-';
  }

  return (
    <Loading isLoading={cases === undefined && jurisdictions === undefined && users === undefined}>
      {(showIfEmpty || (cases?.length !== undefined && cases?.length > 0))
        && (<div>
          {cases?.length ?
            <>

              <Row>
                <Table striped hover style={{ marginLeft: '12px' }}>
                  <thead>
                    <tr className="table-header">
                      <th className="table-header-cell" scope="">
                        Title
                      </th>
                      <th className="table-header-cell" scope="">
                        Case Number
                      </th>
                      <th className="table-header-cell" scope="">
                        Venue
                      </th>
                      <th className="table-header-cell" scope="">
                        Lead Attorney
                      </th>
                      <th className="table-header-cell" scope="col"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {cases?.map(c => {
                      return (
                        <tr className='table-row' key={c.id}>
                          <td className='table-cell'>{c.shortTitle || c.title}</td>
                          <td className='table-cell'>{c.caseNumber ?? '-'}</td>
                          <td className='table-cell'>{venueDisplay(c)}</td>
                          <td className='table-cell'>{leadAttorneyName(c, client, users!)}</td>
                          <td className='actions-cell'>
                            <Link className="btn btn-outline-primary btn-sm wide" to={{
                              pathname: `/clients/${c.clientId}/cases/${c.id}`,
                              state: {
                                client: client,
                                case: c
                              }
                            }}>View Documents</Link>
                          </td>
                        </tr>)
                    })}
                  </tbody>
                </Table>
              </Row>
            </>
            : <div><p>This Client has no Cases yet: <Button variant='link' size='sm' onClick={addCase}>Add one now</Button> or just start by uploading a document.</p></div>}
        </div>)}
    </Loading>
  );
}
